import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import { useAuth } from "../../src/Context/AuthContext";
import DivisionDepartmentModal from "../Components/modals/DivisionDepartmentModal";
import KPIModal from "../Components/modals/KPIModal";
import { useNavigate } from "react-router-dom";

const ExecutiveKPI = () => {
  const criteriaTypes = {
    1: "Divisional Criteria",
    2: "Departmental Criteria",
    3: "Self Target Criteria",
  };


  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [selfRows, setSelfRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [userRole, setUserRole] = useState("");
  const requestToken = localStorage.getItem("request_token");
  const username = localStorage.getItem("username");
  const userType = localStorage.getItem("userType") || "EX";
  const year = localStorage.getItem("year") || new Date().getFullYear();
  const period = localStorage.getItem("period");
  const { request_token } = useAuth();
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [isKPIModalOpen, setIsKPIModalOpen] = useState(false);
  const [isDivisionDepartmentVisible, setIsDivisionDepartmentVisible] =
    useState(false);


  const getServiceNo1 = (row, rowCriteria) => {
    return row.serviceNo || username;
  };

  const getServiceNo = () => {

    const serviceNo = localStorage.getItem("serviceNo");
    if (serviceNo) {
      return serviceNo;
    }

    return localStorage.getItem("username");
  };
  const serviceNo = getServiceNo();
  const openModal = (type) => {
    setModalType(type);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleClose = () => {
    navigate("/executive");
    if (typeof closePopup === 'function') {

    }
  };
  const closeKPIModal = () => {
    setIsKPIModalOpen(false);
  };

  useEffect(() => {
    const fetchUserName = async () => {
      try {
        const response = await fetch(
          "",
          {
            headers: {
              request_token,
            },
          }
        );
        const data = await response.json();
        if (data.StatusCode === 200 && data.ResultSet) {
          setUserName(data.ResultSet.ReportName);
          const jobLevel = data.ResultSet.JobLevel;
          localStorage.setItem("JobLevel", jobLevel);

          if (["03", "04", "04A", "04B"].includes(jobLevel)) {
            setUserRole("Department Head");
          } else if (["02A", "02"].includes(jobLevel)) {
            setUserRole("Division Head");
          } else if (["01A", "01"].includes(jobLevel)) {
            setUserRole("MD / Chairman");
          } else {
            setUserRole("Unknown Role");
          }
        }
      } catch (error) {
        console.error("Error fetching user details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUserName();
  }, [request_token]);

  useEffect(() => {
    const missingValues = [];
    if (!localStorage.getItem("year")) missingValues.push("Year");
    if (!localStorage.getItem("period")) missingValues.push("Period");

    if (missingValues.length > 0) {
      Swal.fire({
        title: "Warning!",
        text: `Please select "${missingValues.join(
          " And "
        )}" before proceeding.`,
        icon: "warning",
      });
    } else {
      checkJobLevel();
    }
  }, []);

  useEffect(() => {
    checkJobLevel();
  }, []);

  useEffect(() => {
    if (userRole) {
      fetchExistingData();
      fetchSelfTargetData();
    }
  }, [userRole]);

  const checkJobLevel = () => {
    const jobLevel = localStorage.getItem("JobLevel") || "";

    const allowedJobLevels = [
      "03",
      "04",
      "04A",
      "04B",
      "02A",
      "02",
      "01A",
      "01",
    ];

    if (allowedJobLevels.includes(jobLevel)) {
      setIsDivisionDepartmentVisible(true);
    } else {
      setIsDivisionDepartmentVisible(false);
    }

    if (["03", "04", "04A", "04B"].includes(jobLevel)) {
      setUserRole("Department Head");
    } else if (["02A", "02"].includes(jobLevel)) {
      setUserRole("Division Head");
    } else if (["01A", "01"].includes(jobLevel)) {
      setUserRole("MD / Chairman");
    } else {
      setUserRole("Employee");
    }
  };

  const isCriteriaDisabled = (criteriaKey) => {
    if (userRole === "Department Head") {
      return criteriaKey === "1";
    } else if (userRole === "Employee") {
      return criteriaKey === "1" || criteriaKey === "2";
    }
    return false;
  };





  const fetchExistingData = async () => {
    try {
      setIsLoading(true);
      const headers = {
        "Content-Type": "application/json",
        request_token: requestToken,
      };

      const jobLevel = localStorage.getItem("JobLevel") || "";
      let diviCode = localStorage.getItem("DivisionCode") || localStorage.getItem("DiviCode") || "";
      let depCode = localStorage.getItem("DepartmentCode") || localStorage.getItem("DepCode") || "";

      let criteriaType = "";
      if (["02A", "02", "01A", "01"].includes(jobLevel)) {
        criteriaType = "1";
      } else if (["03", "04", "04A", "04B"].includes(jobLevel)) {
        criteriaType = "2";
      }

      const kpiFormResponse = await fetch(
        `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/KpiFormLoad?year=${year}&KPI_Divition=${diviCode}&KPI_Department=${depCode}&UserType=${userType}`,
        { headers }
      );
      if (!kpiFormResponse.ok) {
        throw new Error(`KPI Form Load API Error ${kpiFormResponse.status}`);
      }
      const kpiFormData = await kpiFormResponse.json();
      console.log("KPI Form Load Response:", kpiFormData);

      let initialRows = [];
      if (kpiFormData.ResultSet && Array.isArray(kpiFormData.ResultSet)) {
        initialRows = kpiFormData.ResultSet
          .filter(item =>
            (criteriaType === "1" && item.KPI_Criteria === "D") ||
            (criteriaType === "2" && item.KPI_Criteria === "E")
          )
          .map(item => {

            let targetDate = null;
            try {
              targetDate = item.KPI_TDate ? new Date(item.KPI_TDate) : new Date();
            } catch (e) {
              console.warn("Invalid date format:", item.KPI_TDate);
              targetDate = new Date();
            }
            return {
              kpiCode: item.KPI_Code || "",
              criteria: item.KPI_Criteria === "D" ? "1" : "2",
              goalTitle: item.KPI_GTitle || "",
              targetDate: targetDate,
              weightage: item.KPI_Weight || "0",
              fullScore: "0",
              KPI_Status: "A"
            };
          });
      }

      const kpiRowMap = {};
      initialRows.forEach(row => {
        kpiRowMap[row.kpiCode] = row;
      });

      try {
        const kpiDetailsResponse = await fetch(
          `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/GetKPIDetails?year=${year}&peroid=${period}&UserType=${userType}&KPI_Divition=${diviCode}&KPI_Department=${depCode}`,
          { headers }
        );
        if (kpiDetailsResponse.ok) {
          const kpiDetailsData = await kpiDetailsResponse.json();
          console.log("KPI Details Response:", kpiDetailsData);
          if (kpiDetailsData.ResultSet && Array.isArray(kpiDetailsData.ResultSet)) {

            kpiDetailsData.ResultSet.forEach(item => {
              const kpiCode = item.KPI_Code || "";
              if (kpiRowMap[kpiCode]) {

                kpiRowMap[kpiCode].weightage = item.KPI_Weight || kpiRowMap[kpiCode].weightage;
                kpiRowMap[kpiCode].fullScore = item.KPI_Score || "0";
              }
            });
          }
        } else {
          console.warn(`KPI Details API returned status ${kpiDetailsResponse.status}, continuing with form data only`);
        }
      } catch (detailsError) {
        console.warn("Error fetching KPI details, continuing with form data only:", detailsError);
      }

      const finalRows = Object.values(kpiRowMap);
      console.log("Final rows:", finalRows);
      setRows(finalRows);
    } catch (error) {
      console.error("Error fetching existing data:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to load KPI details: " + error.message,
        icon: "error"
      });
      setRows([]);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSelfTargetData = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        request_token: requestToken,
      };


      const formLoadResponse = await fetch(
        `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/KpiFormLoad?year=${year}&KPI_Divition=&KPI_Department=&serviceNo=${serviceNo}&UserType=${userType}`,
        { headers }
      );

      if (!formLoadResponse.ok) {
        throw new Error(`API Error ${formLoadResponse.status}`);
      }

      const formLoadData = await formLoadResponse.json();


      const kpiDetailsResponse = await fetch(
        `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/GetKPIDetails?year=${year}&serviceNo=${serviceNo}&UserType=${userType}&peroid=${period}`,
        { headers }
      );

      if (!kpiDetailsResponse.ok) {
        throw new Error(`API Error ${kpiDetailsResponse.status}`);
      }

      const kpiDetailsData = await kpiDetailsResponse.json();


      const processedSelfRows = formLoadData.ResultSet.map(item => {

        const matchingKpiDetail = kpiDetailsData.ResultSet.find(
          kpi => kpi.KPI_Code === item.KPI_Code
        ) || {};

        return {
          kpiCode: item.KPI_Code,
          criteria: "3",
          goalTitle: item.KPI_GTitle,
          targetDate: item.KPI_TDate ? new Date(item.KPI_TDate) : new Date(),
          weightage: matchingKpiDetail.KPI_Weight || "0",
          fullScore: matchingKpiDetail.KPI_Score || "0",
          KPI_Status: "A"
        };
      });

      setSelfRows(processedSelfRows);
    } catch (error) {
      console.error("Error fetching self-target data:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to load self-target KPI details",
        icon: "error"
      });
    }
  };

  const handleAddRow = (criteriaKey) => {
    const newRow = {
      kpiCode: "",
      criteria: criteriaKey === "3" ? "3" : criteriaKey,
      goalTitle: "",
      targetDate: new Date(),
      weightage: "0",
      fullScore: "0",
    };

    if (criteriaKey === "3") {
      const totalWeightage = selfRows.reduce(
        (sum, row) => sum + parseFloat(row.weightage || 0),
        0
      );

      const totalFullScore = selfRows.reduce(
        (sum, row) => sum + parseFloat(row.fullScore || 0),
        0
      );

      if (totalWeightage + parseFloat(newRow.weightage || 0) > 100) {
        Swal.fire({
          title: "Error!",
          text: "Total Weightage Cannot Exceed 100",
          icon: "error",
        });
        return;
      }

      if (totalFullScore + parseFloat(newRow.fullScore || 0) > 100) {
        Swal.fire({
          title: "Error!",
          text: "Total Full Score Cannot Exceed 100",
          icon: "error",
        });
        return;
      }

      setSelfRows((prevRows) => [newRow, ...prevRows]);
      return;
    }

    const totalWeightage = rows
      .filter((row) => row.criteria === criteriaKey)
      .reduce((sum, row) => sum + parseFloat(row.weightage || 0), 0);

    const totalFullScore = rows
      .filter((row) => row.criteria === criteriaKey)
      .reduce((sum, row) => sum + parseFloat(row.fullScore || 0), 0);

    if (totalWeightage + parseFloat(newRow.weightage || 0) > 100) {
      Swal.fire({
        title: "Error!",
        text: "Total Weightage Cannot Exceed 100",
        icon: "error",
      });
      return;
    }

    if (totalFullScore + parseFloat(newRow.fullScore || 0) > 100) {
      Swal.fire({
        title: "Error!",
        text: "Total Full Score Cannot Exceed 100",
        icon: "error",
      });
      return;
    }

    setRows((prevRows) => [newRow, ...prevRows]);
  };
  const [deletedRows, setDeletedRows] = useState([]);
  const [deletedSelfRows, setDeletedSelfRows] = useState([]);

  const handleDeleteRow = (index, criteriaKey) => {

    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this KPI entry?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (criteriaKey === "3") {

          const rowToDelete = selfRows[index];


          if (rowToDelete.kpiCode) {
            try {
              const deletionPayload = {
                KPI_Criteria: "S",
                KPI_ServiceNo: serviceNo,
                KPI_GTitle: rowToDelete.goalTitle,
                KPI_TDate: formatDate(rowToDelete.targetDate),
                KPI_Status: "I",
                KPI_Code: rowToDelete.kpiCode,
                KPI_Weight: rowToDelete.weightage,
                KPI_Score: rowToDelete.fullScore,
                KPI_Year: year
              };

              await fetch(
                `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/SaveKPICriteriaDetails?UserType=${userType}&year=${year}`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    request_token: requestToken
                  },
                  body: JSON.stringify([deletionPayload])
                }
              );
            } catch (error) {
              console.error("Error deleting KPI entry:", error);
              Swal.fire("Error", "Failed to delete KPI entry", "error");
              return;
            }
          }


          setSelfRows(selfRows.filter((_, i) => i !== index));
        } else {

          const rowToDelete = rows[index];


          if (rowToDelete.kpiCode) {
            try {
              const deletionPayload = {
                KPI_Criteria: rowToDelete.criteria === "1" ? "D" : "E",
                KPI_ServiceNo: serviceNo,
                KPI_GTitle: rowToDelete.goalTitle,
                KPI_TDate: formatDate(rowToDelete.targetDate),
                KPI_Status: "I",
                KPI_Code: rowToDelete.kpiCode,
                KPI_Weight: rowToDelete.weightage,
                KPI_Score: rowToDelete.fullScore,
                KPI_Year: year
              };

              await fetch(
                `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/SaveKPICriteriaDetails?UserType=${userType}&year=${year}`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    request_token: requestToken
                  },
                  body: JSON.stringify([deletionPayload])
                }
              );
            } catch (error) {
              console.error("Error deleting KPI entry:", error);
              Swal.fire("Error", "Failed to delete KPI entry", "error");
              return;
            }
          }


          setRows(rows.filter((_, i) => i !== index));
        }


        Swal.fire(
          'Deleted!',
          'Your KPI entry has been deleted.',
          'success'
        );
      }
    });
  };

  const handleInputChange = (index, field, value, criteriaKey) => {
    if (parseFloat(value) < 0) {
      Swal.fire({
        title: "Error!",
        text: "Negative values are not allowed",
        icon: "error",
      });
      return;
    }

    if (criteriaKey === "3") {
      const newSelfRows = [...selfRows];

      if (field === "fullScore") {
        if (parseFloat(value) > parseFloat(newSelfRows[index].weightage)) {
          Swal.fire({
            title: "Error!",
            text: " Score Cannot Be Greater Than Weightage",
            icon: "error",
          });
          return;
        }
      }

      newSelfRows[index][field] = value;

      const totalWeightage = newSelfRows.reduce(
        (sum, row) => sum + parseFloat(row.weightage || 0),
        0
      );
      const totalFullScore = newSelfRows.reduce(
        (sum, row) => sum + parseFloat(row.fullScore || 0),
        0
      );

      if (totalWeightage > 100) {
        Swal.fire({
          title: "Error!",
          text: "Total Weightage Cannot Exceed 100",
          icon: "error",
        });
        return;
      }

      if (totalFullScore > 101) {
        Swal.fire({
          title: "Error!",
          text: "Total Full Score Cannot Exceed 100",
          icon: "error",
        });
        return;
      }

      setSelfRows(newSelfRows);
      return;
    }

    const newRows = [...rows];

    if (field === "fullScore") {
      if (parseFloat(value) > parseFloat(newRows[index].weightage)) {
        Swal.fire({
          title: "Error!",
          text: " Score Cannot Be Greater Than Weightage",
          icon: "error",
        });
        return;
      }
    }

    newRows[index][field] = value;

    const totalWeightage = newRows
      .filter((row) => row.criteria === newRows[index].criteria)
      .reduce((sum, row) => sum + parseFloat(row.weightage || 0), 0);

    const totalFullScore = newRows
      .filter((row) => row.criteria === newRows[index].criteria)
      .reduce((sum, row) => sum + parseFloat(row.fullScore || 0), 0);

    if (totalWeightage > 100) {
      Swal.fire({
        title: "Error!",
        text: "Total Weightage Cannot Exceed 100",
        icon: "error",
      });
      return;
    }

    if (totalFullScore > 100) {
      Swal.fire({
        title: "Error!",
        text: "Total  Score Cannot Exceed 100",
        icon: "error",
      });
      return;
    }

    setRows(newRows);
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}/${month}/${day}`;
  };

  const handleSave = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        request_token: requestToken,
      };

      const username = localStorage.getItem("username");

      const kpiDetailsPayload = [
        ...rows.map((row) => ({
          KPI_ServiceNo: getServiceNo1(row.criteria === "1" ? "D" : "E"),
          KPI_Criteria: row.criteria === "1" ? "D" : "E",
          KPI_Code: row.kpiCode,
          KPI_Weight: row.weightage,
          KPI_Score: row.fullScore,
          KPI_Status: "A"
        })),
        ...selfRows.map((row) => ({
          KPI_ServiceNo: getServiceNo("S"),
          KPI_Criteria: "S",
          KPI_Code: row.kpiCode,
          KPI_Weight: row.weightage,
          KPI_Score: row.fullScore,
          KPI_Status: "A"
        })),
        ...deletedRows.map((row) => ({
          KPI_ServiceNo: getServiceNo1(row.criteria === "1" ? "D" : "E"),
          KPI_Criteria: row.criteria === "1" ? "D" : "E",
          KPI_Code: row.kpiCode,
          KPI_Weight: row.weightage,
          KPI_Score: row.fullScore,
          KPI_Status: "I"
        })),
        ...deletedSelfRows.map((row) => ({
          KPI_ServiceNo: getServiceNo("S"),
          KPI_Criteria: "S",
          KPI_Code: row.kpiCode,
          KPI_Weight: row.weightage,
          KPI_Score: row.fullScore,
          KPI_Status: "I"
        })),
      ];

      const kpiDetailsResponse = await fetch(
        `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/SaveKPIDetails?UserType=${userType}&year=${year}&peroid=${period}`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(kpiDetailsPayload),
        }
      );

      if (!kpiDetailsResponse.ok) {
        throw new Error("Failed to save KPI details");
      }

      Swal.fire({
        title: "Success!",
        text: "KPI details saved successfully",
        icon: "success",
      }).then(() => {
        window.location.reload();
      });
    } catch (error) {
      console.error("Error saving KPI details:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to save KPI details",
        icon: "error",
      });
    }
  };

  if (isLoading) {
    return (
      <div className="space-y-4">
        <div className="h-4 bg-gray-300 rounded w-3/4 animate-pulse"></div>
        <div className="h-4 bg-gray-300 rounded w-2/4 animate-pulse"></div>
        <div className="h-4 bg-gray-300 rounded w-full animate-pulse"></div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-2 py-4 md:p-4">
      <div className="bg-white shadow-lg rounded-lg mb-6 overflow-hidden">
        <DivisionDepartmentModal

        />
        <h2 className="text-lg md:text-xl font-bold p-4 md:p-6 bg-indigo-100">
          KPI Entry Details
        </h2>

        <div className="p-3 md:p-6">
          <div
            className="overflow-x-auto"
            style={{ maxHeight: "400px", overflowY: "auto" }}
          >
            <table className="w-full border-collapse   text-xs md:text-sm">
              <thead className="bg-gray-100 sticky top-0">
                <tr>
                  <th className="border border-gray-300 px-2 py-2 md:px-4 md:py-3 text-left">
                    Criteria
                  </th>
                  <th className="border border-gray-300 px-2 py-2 md:px-4 md:py-3 text-left">
                    Goal Title
                  </th>
                  <th className="border border-gray-300 px-2 py-2 md:px-4 md:py-3 text-left">
                    Target Date
                  </th>
                  <th className="border border-gray-300 px-2 py-2 md:px-4 md:py-3 text-left">
                    Weight (%)
                  </th>
                  <th className="border border-gray-300 px-2 py-2 md:px-4 md:py-3 text-left">
                    Score
                  </th>
                  <th className="border border-gray-300 px-2 py-2 md:px-4 md:py-3 text-left">
                    ( Score / Weight )
                  </th>

                </tr>
              </thead>

              <tbody>
                {Object.entries(criteriaTypes).map(([key, criteria]) => (
                  <React.Fragment key={key}>
                    <tr className="bg-gray-100">
                      <td
                        colSpan="6"
                        className="border border-gray-300 px-4 py-2 font-bold"
                      >
                        {criteria}

                      </td>
                    </tr>
                    {key !== "3"
                      ? rows
                        .filter((row) => row.criteria === key)
                        .map((row, index) => (
                          <tr
                            key={index}
                            className={
                              index % 2 === 0 ? "bg-white" : "bg-gray-50"
                            }
                          >
                            <td className="border border-gray-300 px-4 py-2"></td>
                            <td className="border border-gray-300 px-4 py-2">
                              <input
                                type="text"
                                className="w-full px-2 py-1 border rounded"
                                value={row.goalTitle}
                                onChange={(e) =>
                                  handleInputChange(
                                    rows.indexOf(row),
                                    "goalTitle",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter Goal Title"
                                disabled={isCriteriaDisabled(key)}
                              />
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              <DatePicker
                                selected={row.targetDate}
                                onChange={(date) =>
                                  handleInputChange(
                                    rows.indexOf(row),
                                    "targetDate",
                                    date
                                  )
                                }
                                className="w-full px-2 py-1 border rounded"
                                disabled={isCriteriaDisabled(key)}
                              />
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              <input
                                type="number"
                                className="w-full px-2 py-1 border rounded"
                                value={row.weightage}
                                onChange={(e) =>
                                  handleInputChange(
                                    rows.indexOf(row),
                                    "weightage",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter Weightage"
                                disabled={isCriteriaDisabled(key)}
                              />
                            </td>
                            <td className="border border-gray-300 px-4 py-2">
                              <input
                                type="number"
                                className="w-full px-2 py-1 border rounded"
                                value={row.fullScore}
                                onChange={(e) =>
                                  handleInputChange(
                                    rows.indexOf(row),
                                    "fullScore",
                                    e.target.value
                                  )
                                }
                                placeholder="Enter Full Score"
                                disabled={isCriteriaDisabled(key)}
                              />
                            </td>
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              ( {row.fullScore} / {row.weightage} )
                            </td>

                          </tr>
                        ))
                      : selfRows.map((row, index) => (
                        <tr
                          key={index}
                          className={
                            index % 2 === 0 ? "bg-white" : "bg-gray-50"
                          }
                        >
                          <td className="border border-gray-300 px-4 py-2"></td>
                          <td className="border border-gray-300 px-4 py-2">
                            <input
                              type="text"
                              className="w-full px-2 py-1 border rounded"
                              value={row.goalTitle}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "goalTitle",
                                  e.target.value,
                                  "3"
                                )
                              }
                              placeholder="Enter Goal Title"
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <DatePicker
                              selected={row.targetDate}
                              onChange={(date) =>
                                handleInputChange(
                                  index,
                                  "targetDate",
                                  date,
                                  "3"
                                )
                              }
                              className="w-full px-2 py-1 border rounded"
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <input
                              type="number"
                              className="w-full px-2 py-1 border rounded"
                              value={row.weightage}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "weightage",
                                  e.target.value,
                                  "3"
                                )
                              }
                              placeholder="Enter Weightage"
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            <input
                              type="number"
                              className="w-full px-2 py-1 border rounded"
                              value={row.fullScore}
                              onChange={(e) =>
                                handleInputChange(
                                  index,
                                  "fullScore",
                                  e.target.value,
                                  "3"
                                )
                              }
                              placeholder="Enter Full Score"
                            />
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            ( {row.fullScore} / {row.weightage} )
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            <button
                              className="bg-red-500 text-white py-1 px-3 rounded"
                              onClick={() => handleDeleteRow(index, "3")}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex mt-10 justify-end space-x-1">
            <button
              className="px-3 py-1 md:px-4 md:py-2 bg-blue-500 text-white font-semibold rounded hover:bg-blue-600 transition duration-300 text-xs md:text-sm"
              onClick={handleSave}
            >
              Save
            </button>
            <button
              className="px-3 py-1 md:px-4 md:py-2 bg-red-500 text-white font-semibold rounded hover:bg-red-600 transition duration-300 text-xs md:text-sm"
              onClick={handleClose}
            >
              Close
            </button>
          </div>
        </div>
      </div>

      {isKPIModalOpen && <KPIModal closePopup={closeKPIModal} />}
    </div>
  );
};

export default ExecutiveKPI;